export var MODE_IDLE = 'idle';
export var MODE_PANNING = 'panning';
export var MODE_ZOOMING = 'zooming';
export var TOOL_AUTO = 'auto';
export var TOOL_NONE = 'none';
export var TOOL_PAN = 'pan';
export var TOOL_ZOOM_IN = 'zoom-in';
export var TOOL_ZOOM_OUT = 'zoom-out';
export var POSITION_NONE = 'none';
export var POSITION_TOP = 'top';
export var POSITION_RIGHT = 'right';
export var POSITION_BOTTOM = 'bottom';
export var POSITION_LEFT = 'left';
export var ACTION_ZOOM = 'zoom';
export var ACTION_PAN = 'pan';
export var ALIGN_CENTER = 'center';
export var ALIGN_LEFT = 'left';
export var ALIGN_RIGHT = 'right';
export var ALIGN_TOP = 'top';
export var ALIGN_BOTTOM = 'bottom';
export var ALIGN_COVER = 'cover';
export var INITIAL_VALUE = {};